import Box from '@mui/material/Box'
import { ITooltip } from '../../index'
import Drag from '../../Icons/js/icons/Drag'

const DragIconButton = ({ className, controls }) => (
  <Box
    className={className}
    onPointerDown={(event) => controls.start(event)}
    sx={{
      cursor: 'grab',
      height: 16,
      margin: '3px',
      width: 16,
      '& > div': { height: 16 }
    }}
  >
    <ITooltip placement='top' content='Move'>
      <Drag />
    </ITooltip>
  </Box>
)

export default DragIconButton
